import Aboutpages from "../component/aboutpages"
import About from "../component/about"
import ThreeCards from "../component/cards"
import Doctor from "../component/doctor"
import News from "../component/news"
function AboutDrop(){
    return(
        <>
        <Aboutpages/>
        <About/>
        <ThreeCards/>
        <Doctor/>
        <News/>
        </>
    )
}
export default AboutDrop